export var ContactEmailsCondition;
(function (ContactEmailsCondition) {
    ContactEmailsCondition["Clue"] = "clue";
    ContactEmailsCondition["Company"] = "company";
    ContactEmailsCondition["Opportunity"] = "opportunity";
    ContactEmailsCondition["OpenSea"] = "open_sea";
})(ContactEmailsCondition || (ContactEmailsCondition = {}));
[];
[];
[];
